// CollectionRoute: Route-level container for the Collection page.
// Öffnet bei Kartenklick das Karten-Modal (CardDetail); rendert VirtualizedCollectionPage.
import React, { useState } from 'react';
import VirtualizedCollectionPage from '../components/VirtualizedCollectionPage';
import ProfileBanner from '../components/ProfileBanner';
import ImportCollectionModal from '../components/ImportCollectionModal';
import CardDetail from '../components/CardDetail';
import { useAuth } from '../context/AuthContext';
import { useProfile } from '../context/ProfileContext';

export default function CollectionRoute() {
  const { authToken } = useAuth();
  const { viewedUserId, isOwnProfile } = useProfile();

  const [detailCard, setDetailCard] = useState(null); // { oracleId, scryfallId, name, typeLine, imageUrl, imageUrlBack }

  const [importOpen, setImportOpen] = useState(false);
  const [importMode, setImportMode] = useState('csv');

  const handleCardClickInCollection = (card) => {
    if (!card?.oracleId) return;
    setDetailCard({
      oracleId: card.oracleId,
      scryfallId: card.cardId,
      name: card.name,
      typeLine: card.typeLine,
      imageUrl: card.imageUrl,
      imageUrlBack: card.imageUrlBack && String(card.imageUrlBack).trim() !== '' ? card.imageUrlBack : undefined,
      imageOrientation: card.imageOrientation,
    });
  };

  return (
    <>
      <ProfileBanner />
      <VirtualizedCollectionPage
        authToken={authToken}
        handleCardClickInCollection={handleCardClickInCollection}
        viewedUserId={viewedUserId}
        isOwnProfile={isOwnProfile}
        onImportCsv={() => { setImportMode('csv'); setImportOpen(true); }}
        onImportDrive={() => { setImportMode('drive'); setImportOpen(true); }}
      />
      <CardDetail
        open={!!detailCard}
        onOpenChange={(next) => { if (!next) setDetailCard(null); }}
        oracleId={detailCard?.oracleId}
        scryfallId={detailCard?.scryfallId}
        fallback={detailCard}
        context="add-to-deck"
      />
      <ImportCollectionModal
        open={importOpen}
        mode={importMode}
        onOpenChange={setImportOpen}
      />
    </>
  );
}
